import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/soc2-logo.png")